import { useNavigate, useSearchParams } from 'react-router-dom';

function AuthErrorPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const message = searchParams.get('message') || 'Ověření selhalo';

  return (
    <div className="auth-error-page">
      <div className="container">
        <div className="error-container">
          <div className="error-icon">✕</div>
          <h1>Ověření selhalo</h1>
          <p>{message}</p>
          <button 
            onClick={() => navigate('/login')} 
            className="btn-primary"
          >
            Zpět na přihlášení
          </button>
        </div>
      </div>
    </div>
  );
}

export default AuthErrorPage;